import Translation from './translation';

export default class TranslationProfileIntro extends Translation {

  constructor(args){

    super(args);

    this.sectionSelector = '[data-content=company-description-section]:visible';

    this.sectionUniqueId = 0;

    this.$scope.find('#company-intro-form').submit(this.addHiddenFieldsToForm.bind(this));

    // Events for sections move-up, move-down, delete.

    this.$scope.on('click', '[data-button-type=move-down-btn]', ev => {
      const $section = $(ev.target).closest(this.sectionSelector);
      this.moveDown($section);
    });

    this.$scope.on('click', '[data-button-type=move-up-btn]', ev => {
      const $section = $(ev.target).closest(this.sectionSelector);
      this.moveUp($section);
    });

    this.$scope.on('click', '[data-button-type=section-delete]', ev => {
      const $deleteButton = $(ev.target);
      if(!confirm($deleteButton.attr('data-confirm-text'))){
        return;
      }
      const $section = $deleteButton.closest(this.sectionSelector);
      this.removeSection($section);
    });

    const $data = $('[data-content=initial-sections-json]');
    if(typeof $data !== 'undefined' && $data.length !== 0){
      this.renderInitSections(JSON.parse($('[data-content=initial-sections-json]').html()));
    }

  }

  // When submitting form, add to the form hidden fields that contain sections data.
  // Example:
  // ja_company_description_section[][title] = 'Title for JA section 1'
  // ja_company_description_section[][title] = 'Title for JA section 2'
  // ja_company_description_section[][title] = 'Title for JA section 3'
  // (...)
  // en_company_description_section[][title] = 'Title for EN section 1'
  // en_company_description_section[][body] = 'Body for EN section 1'
  // etc.
  addHiddenFieldsToForm(ev){

    const sectionsData = this.getSectionsData();
    const formParamsPrefix = 'company_profile';
    const $form = $(ev.target);

    sectionsData.forEach((section, idx) => {
      ['title', 'body', 'caption'].forEach(attribute => {
        ['ja', 'en'].forEach(lang => {
          let hiddenField = $('<input>')
            .attr('type', 'hidden')
            .attr('name', `${formParamsPrefix}[company_description_section][${idx}_${lang}_${attribute}]`).val(section[lang][attribute]);
          $form.append(hiddenField);
        });
      });

      ['category', 'company_image_id'].forEach(attribute => {
        let hiddenField = $('<input>')
            .attr('type', 'hidden')
            .attr('name', `${formParamsPrefix}[company_description_section][${idx}_${attribute}]`).val(section[attribute]);
          $form.append(hiddenField);
      });
    });
  }

  shouldEnableTranslationButton(inputContent){

    const formStatus = this.getFormStatus();

    // One or both checkboxes are disabled.
    if(!formStatus.srcLangCheckbox.enabled || !formStatus.destLangCheckbox.enabled){
      return false;
    }

    return inputContent.length > 0;
  }

  // This checkbox is only displayed in DJ contracts, and it's always clickable.
  // For WA and WAWW contracts, it's not necessary to disable it.
  shouldEnableShowNoticeCheckbox(){
    return true;
  }

  shouldEnableLanguageDirectionToggleButton(){

    const formStatus = this.getFormStatus();

    // One or both checkboxes are disabled.
    if(!formStatus.srcLangCheckbox.enabled || !formStatus.destLangCheckbox.enabled){
      return false;
    }

    return true;
  }

  shouldEnableInput(inputLang){
    const formStatus = this.getFormStatus();
    const checkbox = formStatus.srcLang === inputLang ? formStatus.srcLangCheckbox : formStatus.destLangCheckbox;
    return checkbox.enabled;
  }


  // Collects data from sections form into a JS object, like this:
  //
  // [
  //   { 'ja': { 'title': '...', 'body': '...', 'caption': '...' },
  //     'en': { 'title': '...', 'body': '...', 'caption': '...' },
  //     'category': 'none',
  //     'company_image_id': '1'
  //   },
  //   ...
  // ]
  getSectionsData(){

    const sections = [];

    this.getSections().each((i, ele) => {
      const $section = $(ele);

      const newSection = {
        ja: {},
        en: {}
      };

      ['title', 'body', 'caption'].forEach(attribute => {
        ['ja', 'en'].forEach(lang => {
          newSection[lang][attribute] = $section.find(`[data-input-lang=${lang}][name=${attribute}]`).val();
        });
      });

      newSection['company_image_id'] = $section.find(`[name=company_image_id]`).val();
      newSection['category'] = $section.find(`[data-content=radio-button-group][data-group-name=category] input:checked`).val();

      sections.push(newSection);

    });

    return sections;
  }

  renderInitSections(sections){

    for(let i=0; i<sections.length; i++){
      const section = sections[i];
      const $section = this.createSection({
        jaTitle: section.ja_title,
        jaBody: section.ja_body,
        jaCaption: section.ja_caption,
        enTitle: section.en_title,
        enBody: section.en_body,
        enCaption: section.en_caption,
        uploadImagePath: section.upload_image_path,
        imageTag: section.image_tag,
        isNewSection: section.new_section,
        companyImageId: section.company_image_id,
        category: section.category
      });
      this.appendSection($section);
    }
  }


  getSectionByIndex(idx){
    return this.$scope.find(`${this.sectionSelector}[data-section-index=${idx}]`);
  }

  createSection(data = { category: 'none' }){

    const jaTitle = data.jaTitle;
    const jaBody = data.jaBody;
    const jaCaption = data.jaCaption;
    const enTitle = data.enTitle;
    const enBody = data.enBody;
    const enCaption = data.enCaption;
    const uploadImagePath = data.uploadImagePath;
    const imageTag = data.imageTag;
    const isNewSection = data.isNewSection;
    const companyImageId = data.companyImageId;
    const category = data.category || 'none';

    const $template = this.$scope.find('[data-content=company-description-section-template]').children().first().clone();

    $template.find('[data-toggle="tooltip"]').tooltip({
      content: function () {
        return $(this).attr('title');
      }
    })

    $template.find('[data-input-lang=ja][name=title]').val(jaTitle);
    $template.find('[data-input-lang=en][name=title]').val(enTitle);

    $template.find('[data-input-lang=ja][name=body]').val(jaBody);
    $template.find('[data-input-lang=en][name=body]').val(enBody);

    $template.find('[data-input-lang=ja][name=caption]').val(jaCaption);
    $template.find('[data-input-lang=en][name=caption]').val(enCaption);

    $template.find('[data-display-if=new-section]').toggle(isNewSection);
    $template.find('[data-display-if=not-new-section]').toggle(!isNewSection);

    $template.find('[name=company_image_id]').val(companyImageId);

    // Make all radio button groups have a unique name (currently there's only one per section.)
    $template.find('[data-content=radio-button-group]').each((i, ele) => {
      const $radioGroup = $(ele);
      const prefixName = $(ele).attr('data-group-name');
      $radioGroup.find('input').attr('name', `${prefixName}_${this.sectionUniqueId}`);
    });

    $template.find(`[data-content=radio-button-group][data-group-name=category] input[value=${category}]`).attr('checked', true);

    if(imageTag){
      $template.find('[data-display-if=section-has-photo]').show();
      $template.find('[data-content=image-tag]').html(imageTag);
    } else {
      $template.find('[data-display-if=section-has-photo]').hide();
    }

    if(typeof uploadImagePath === 'string' && uploadImagePath.length > 0 && !isNewSection){
      $template.find('[data-button-type=upload-photo]').show();
      $template.find('[data-button-type=upload-photo]').attr('href', uploadImagePath);
    } else {
      $template.find('[data-button-type=upload-photo]').hide();
    }

    // This is so that TinyMCE can select it.
    // The number in the ID doesn't need to be the same as in the section ID in the parent container.
    $template.find(`[data-editor=true]`).each((i, ele) => {
      const $textarea = $(ele);
      const lang = $textarea.attr('data-input-lang');
      $textarea.attr('id', `mce-editor-${this.sectionUniqueId}-${lang}`);
    });

    this.sectionUniqueId++;

    return $template;
  }

  // Inherited from super class but modified, so that TinyMce editors are updated as well.
  setTranslatedValueToInput($targetElement, text){

    if($targetElement.attr('data-editor')){
      const elemId = $targetElement.attr('id');
      const editor = tinymce.get(elemId);
      editor.setContent(text);
    }

    $targetElement.val(text);
  }

  tinyMceInit($section){

    if(typeof $section !== 'object'){
      throw new Error('Section argument must be an object.');
    }

    function copyTextarea(editor, ev) {
      var $textarea = $(editor.targetElm);
      $textarea.val(editor.getContent());
      $textarea.trigger('keyup');
    }

    const defaultOptions = {
      mode    : 'exact',
      language: gon.locale,
      plugins : 'autolink, charmap, code, lists, paste, preview, save, searchreplace, table, textcolor, visualchars',
      tools   : 'inserttable',
      menubar : 'edit, insert, view, format, table, tools',
      toolbar1: 'undo redo | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent ',
      toolbar2: 'forecolor backcolor | fontselect | fontsizeselect | searchreplace | preview code |',
      font_formats: "デフォルト='ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'メイリオ', Meiryo, Osaka, 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;"+
        "指定無し= ",
      invalid_style: 'font-family',
      paste_retain_style_properties: 'color font-size text-align text_decoration text_indentation',
      forced_root_block: false,
      remove_linebreaks: true,
      relative_urls : false,
      remove_script_host : false,
      convert_urls : true,
      setup: function(ed) {
        ed.on('change', function(e){
          copyTextarea(ed, e);
        });
        ed.on('keydown', function(e){
          copyTextarea(ed, e);
        });
        ed.on('focus', function(e){
          var $textarea = $(ed.targetElm);
          if($textarea.is(':disabled')){
            return;
          }
          var $tr = $textarea.closest('tr');
          var $td = $textarea.closest('td');

          $tr.find('td').hide();
          $td.show();
          $td.attr('colspan', 3);
        });
        ed.on('blur', function(e){
          var editor = tinyMCE.get(ed.id);
          var $textarea = $(editor.getElement());
          var $tr = $textarea.closest('tr');

          $tr.find('td').show();
          $tr.find('td').attr('colspan', 1);
        });
      }
    };

    ["en", "ja"].forEach(lang => {
      const $textarea = $section.find(`[data-editor=true][data-input-lang=${lang}]`);
      const id = $textarea.attr('id');
      const enabled = this.checkboxIsEnabled(lang);
      tinymce.init(Object.assign(defaultOptions, {
        readonly: !enabled,
        selector: `#${id}`
      }));
    });
  }

  removeSection($section){
    $section.fadeOut(() => {
      $section.remove();
      this.sectionPositionOrQuantityChanged();
    });
  }

  // This method must be executed everytime the number and position of sections is changed.
  updateUpDownButtons(){

    const count = this.sectionsCount();

    this.getSections().each((i, ele) => {
      const $section = $(ele);

      const $upBtn = $section.find('[data-button-type=move-up-btn]');
      const $downBtn = $section.find('[data-button-type=move-down-btn]');

      $upBtn.toggle(i !== 0);
      $downBtn.toggle(i !== count - 1);

    });
  }

  // It's necessary to remove TinyMCE attached to a textarea first, and then initialize it again.
  swap($a, $b) {

    tinyMCE.triggerSave();

    [$a, $b].forEach($section => {
      $section.find('[data-editor=true]').each((i, ele) => {
        tinymce.get($(ele).attr('id')).remove()
      });
    });

    let $tmp = $('<div>').hide();
    $a.before($tmp);
    $b.before($a);
    $tmp.replaceWith($b);

    this.tinyMceInit($a);
    this.tinyMceInit($b);
  }

  moveUp($section){
    const $previous = $section.prev(this.sectionSelector);
    this.swap($previous, $section);
    this.sectionPositionOrQuantityChanged();
  }

  moveDown($section){
    const $next = $section.next(this.sectionSelector);
    this.swap($section, $next);
    this.sectionPositionOrQuantityChanged();
  }

  createNewSection(){
    const newSection = this.createSection({ isNewSection: true });
    this.appendSection(newSection);
  }

  sectionPositionOrQuantityChanged(){
    this.updateNewButton();
    this.updateUpDownButtons();
    this.updateIndexAttribute();
  }

  clickButton(){
    if (!gon.is_display_description_section) {
      $("#new-section-add-btn").trigger("click");
    }
  }

  appendSection($section){
    this.$scope.find('[data-content=sections-container]').append($section);
    this.sectionPositionOrQuantityChanged();

    this.tinyMceInit($section);

    this.updateAllTranslationButtons();
    this.updateAllInputs();
  }

  updateIndexAttribute(){
    this.getSections().each((i, ele) => {
      const $section = $(ele);
      $section.attr('data-section-index', i);
    });
  }

  updateNewButton(){
    const sectionsCount = this.sectionsCount();
    this.$scope.find('[data-button-type=new-section-button]').attr('disabled', sectionsCount === 4);
  }

  sectionsCount(){
    return this.getSections().length;
  }

  getSections(){
    return this.$scope.find(this.sectionSelector);
  }
}
